/**
 * Reads the SceneManager off a SceneCanvas ref.
 *
 * SceneCanvas exposes its manager through an imperative handle rather than a
 * plain field, and the handle is absent both before mount and after the WebGL
 * context is torn down — so every caller needs the same two guards. This existed
 * as three separate copies, and two of them omitted the null-check on the ref
 * object itself.
 *
 * @returns {object|null} the SceneManager, or null when the canvas is not ready
 */
export function getSceneManagerFromRef(canvasRef) {
  if (!canvasRef || !canvasRef.current) return null;
  return canvasRef.current.getSceneManager ? canvasRef.current.getSceneManager() : null;
}

export default getSceneManagerFromRef;
